import './external.css';
import { Outlet } from 'react-router-dom';

const External = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default External;
